import React from 'react';
import DynamicIcon from './DynamicIcon';

const IconShowcase = () => {
  // All the icon names from your API mapping
  const iconNames = [
    // Light variants
    'fa-light-gauge',
    'fa-light-car',
    'fa-light-water-temperature',
    'fa-light-transmission',
    'fa-light-tire-flat',
    'fa-light-tire',
    'fa-light-tank-water',
    'fa-light-steering-wheel',
    'fa-light-oil-temperature',
    'fa-light-oil-can-drip',
    'fa-light-oil-can',
    'fa-light-car-wrench',
    'fa-light-engine-warning',
    'fa-light-brake-warning',
    'fa-light-car-battery',
    'fa-light-tire-pressure-warning',
    'fa-light-garage-car',

    // Regular variants
    'fa-regular-gauge',
    'fa-regular-car',
    'fa-regular-water-temperature',
    'fa-regular-transmission',
    'fa-regular-tire-flat',
    'fa-regular-tire',
    'fa-regular-tank-water',
    'fa-regular-steering-wheel',
    'fa-regular-oil-temperature',
    'fa-regular-oil-can-drip',
    'fa-regular-oil-can',
    'fa-regular-car-wrench',
    'fa-regular-engine-warning',
    'fa-regular-brake-warning',
    'fa-regular-car-battery',
    'fa-regular-tire-pressure-warning',
    'fa-regular-garage-car',

    // Duotone variants
    'fa-duotone-gauge',
    'fa-duotone-car',
    'fa-duotone-water-temperature',
    'fa-duotone-transmission',
    'fa-duotone-tire-flat',
    'fa-duotone-tire',
    'fa-duotone-tank-water',
    'fa-duotone-steering-wheel',
    'fa-duotone-oil-temperature',
    'fa-duotone-oil-can-drip',
    'fa-duotone-oil-can',
    'fa-duotone-car-wrench',
    'fa-duotone-engine-warning',
    'fa-duotone-brake-warning',
    'fa-duotone-car-battery',
    'fa-duotone-tire-pressure-warning',
    'fa-duotone-garage-car',

    // CIN-6779: general (non-automotive) service icons
    // Pet & Animal - light variants
    'fa-light-paw',
    'fa-light-dog',
    'fa-light-cat',
    'fa-light-cut',
    'fa-light-bath',

    // Real Estate - light variants
    'fa-light-house',
    'fa-light-key',
    'fa-light-door-open',
    'fa-light-sign',

    // General - light variants
    'fa-light-calendar',
    'fa-light-clock',
    'fa-light-check',
    'fa-light-toolbox',

    // Pet & Animal - regular variants
    'fa-regular-paw',
    'fa-regular-dog',
    'fa-regular-cat',
    'fa-regular-cut',
    'fa-regular-bath',

    // Real Estate - regular variants
    'fa-regular-house',
    'fa-regular-key',
    'fa-regular-door-open',
    'fa-regular-sign',

    // General - regular variants
    'fa-regular-calendar',
    'fa-regular-clock',
    'fa-regular-check',
    'fa-regular-toolbox',

    // Pet & Animal - duotone variants
    'fa-duotone-paw',
    'fa-duotone-dog',
    'fa-duotone-cat',
    'fa-duotone-cut',
    'fa-duotone-bath',

    // Real Estate - duotone variants
    'fa-duotone-house',
    'fa-duotone-key',
    'fa-duotone-door-open',
    'fa-duotone-sign',

    // General - duotone variants
    'fa-duotone-calendar',
    'fa-duotone-clock',
    'fa-duotone-check',
    'fa-duotone-toolbox'
  ];

  const showcaseStyle = {
    padding: '40px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f5f5f5',
    minHeight: '100vh'
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
    gap: '20px',
    marginTop: '20px'
  };

  const iconCardStyle = {
    backgroundColor: 'white',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  };

  const iconNameStyle = {
    fontSize: '14px',
    fontFamily: 'monospace',
    color: '#333',
    wordBreak: 'break-word'
  };

  return (
    <div style={showcaseStyle}>
      <h1>Icon Showcase</h1>
      <p>All supported FontAwesome icons from your API mapping:</p>

      <div style={gridStyle}>
        {iconNames.map(iconName => (
          <div key={iconName} style={iconCardStyle} data-testid={`icon-showcase-${iconName}`}>
            <DynamicIcon
              iconName={iconName}
              size="lg"
              style={{ color: '#007bff', flexShrink: 0 }}
            />
            <span style={iconNameStyle}>{iconName}</span>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '40px', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
        <h2>Size Comparison</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DynamicIcon iconName="fa-regular-car" />
            <span>Default size</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DynamicIcon iconName="fa-regular-car" size="lg" />
            <span>Large size</span>
          </div>
        </div>
      </div>

      <div style={{ marginTop: '20px', padding: '20px', backgroundColor: 'white', borderRadius: '8px' }}>
        <h2>Color Variations</h2>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '20px' }}>
          <DynamicIcon iconName="fa-regular-car" size="lg" style={{ color: '#007bff' }} />
          <DynamicIcon iconName="fa-regular-car" size="lg" style={{ color: '#28a745' }} />
          <DynamicIcon iconName="fa-regular-car" size="lg" style={{ color: '#dc3545' }} />
          <DynamicIcon iconName="fa-regular-car" size="lg" style={{ color: '#ffc107' }} />
          <DynamicIcon iconName="fa-regular-car" size="lg" style={{ color: '#6c757d' }} />
        </div>
      </div>
    </div>
  );
};

export default IconShowcase;